import { graphql } from "gql";

const HAPPYCO_WORK_CATEGORIES_QUERY = graphql(`
  query HappycoWorkCategories($propertyId: String!) {
    happycoWorkCategories(propertyId: $propertyId) {
      ...HappycoWorkCategory
    }
  }
`);

export default HAPPYCO_WORK_CATEGORIES_QUERY;
